import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';

interface KakaoContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function KakaoContactModal({ isOpen, onClose }: KakaoContactModalProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText('gwonbj88').then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9998]"
          />

          {/* Modal */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ type: 'spring', damping: 20, stiffness: 300 }}
            className="fixed inset-0 flex items-center justify-center z-[9999] px-4"
            onClick={onClose}
          >
            <div
              className="bg-white rounded-3xl p-8 w-full max-w-sm shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-[#FEE500] rounded-2xl flex items-center justify-center">
                    <i className="ri-kakao-talk-fill text-2xl text-[#3C1E1E]"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">카카오톡 상담</h3>
                    <p className="text-sm text-gray-500">제주블리</p>
                  </div>
                </div>
                <button
                  onClick={onClose}
                  className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-all cursor-pointer"
                >
                  <i className="ri-close-line text-gray-600 text-lg"></i>
                </button>
              </div>

              {/* ID Box */}
              <div className="bg-[#FFFDE7] border-2 border-[#FEE500] rounded-2xl p-5 mb-5">
                <p className="text-xs text-gray-500 mb-2 font-medium">카카오톡 ID</p>
                <div className="flex items-center justify-between gap-3">
                  <span className="text-2xl font-bold text-[#3C1E1E] tracking-wide">gwonbj88</span>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={handleCopy}
                    className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-bold transition-all whitespace-nowrap cursor-pointer ${
                      copied
                        ? 'bg-green-500 text-white'
                        : 'bg-[#FEE500] text-[#3C1E1E] hover:bg-yellow-300'
                    }`}
                  >
                    <i className={`text-base ${copied ? 'ri-check-line' : 'ri-file-copy-line'}`}></i>
                    {copied ? '복사됨!' : 'ID 복사'}
                  </motion.button>
                </div>
              </div>

              {/* Steps */}
              <div className="space-y-3 mb-6">
                <p className="text-sm font-bold text-gray-700 mb-3">이렇게 연결하세요</p>
                {[
                  { step: '1', text: '카카오톡 앱을 실행하세요' },
                  { step: '2', text: '친구추가 → ID로 추가 선택' },
                  { step: '3', text: 'gwonbj88 검색 후 채팅 시작' },
                ].map((item) => (
                  <div key={item.step} className="flex items-center gap-3">
                    <div className="w-6 h-6 bg-[#FEE500] rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-xs font-bold text-[#3C1E1E]">{item.step}</span>
                    </div>
                    <span className="text-sm text-gray-600">{item.text}</span>
                  </div>
                ))}
              </div>

              {/* Phone fallback */}
              <div className="border-t border-gray-100 pt-5">
                <p className="text-xs text-gray-400 text-center mb-3">또는 전화로 바로 문의</p>
                <a
                  href="tel:010-5685-7818"
                  className="flex items-center justify-center gap-2 w-full py-3 rounded-2xl bg-gray-100 hover:bg-gray-200 transition-all text-gray-700 font-bold text-sm cursor-pointer"
                >
                  <i className="ri-phone-line text-base"></i>
                  010-5685-7818
                </a>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
